/**
 * AuthCallback.js - SSO Authentication Callback Handler
 * Handles the OIDC redirect callback after SSO login
 */

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth as useOidcAuth } from 'react-oidc-context';
import { config } from '../config';
import { logger } from '../logger';

function AuthCallback() {
  const oidcAuth = useOidcAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Once the OIDC library processes the callback and user is authenticated
    if (oidcAuth.isAuthenticated && oidcAuth.user) {
      // Store auth provider type
      localStorage.setItem(config.storageKeys.authProvider, 'sso');
      logger.info('SSO authentication successful', { email: oidcAuth.user.profile?.email });
      navigate('/', { replace: true });
    }
  }, [oidcAuth.isAuthenticated, oidcAuth.user, navigate]);

  if (oidcAuth.isLoading) {
    return (
      <div className="login-container">
        <div className="login-card">
          <h1>{config.appName}</h1>
          <p>Processing login...</p>
          <div className="loading-spinner"></div>
        </div>
      </div>
    );
  }

  if (oidcAuth.error) {
    logger.error('SSO authentication error', oidcAuth.error);
    return (
      <div className="login-container">
        <div className="login-card">
          <h1>Authentication Error</h1>
          <p>{oidcAuth.error.message}</p>
          <button 
            className="sso-login-btn"
            onClick={() => navigate('/', { replace: true })}
          >
            Back to Login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="login-container">
      <div className="login-card">
        <h1>{config.appName}</h1>
        <p>Redirecting...</p>
      </div>
    </div>
  );
}

export default AuthCallback;

